import {
    DIC
} from '@/const/dic'
import {
    validateChinese
} from '@/util/validate'
import {
    formatterTime
} from '@/util/util'


const validateName = (rule, value, callback) => {
    if (!validateChinese(value) || value.length > 30 || value.length < 1) {
        callback(new Error('红包名称为1-30位中文'))
    } else {
        callback();
    }
}

export const supplyListOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: false,
    menuWidth: '300',
    labelWidth: '150',
    defaultSort:{
        prop: 'createTime',
        order: 'descending'
    },
    column: [
        {
            label: "供货单编号",
            prop: "supplyListNum",
            type: "input",
            width:"200",
            addVisdiplay: false,
            editVisdiplay: false,
            search: true
        },
        {
            label: "预约商",
            prop: "buyerName",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "联系人",
            prop: "contactsName",
            search: true,
            type: 'input',
            rules: [{
                required: true,
                trigger: "blur",
                validator: validateName
            }]
        },
        {
            label: "联系人电话",
            prop: "contactsMobile",
            type: 'input',
            rules: [{
                trigger: "blur",
                required: true,
                message: "请输入电话"
            }]
        },
        {
            label: "配送方式",
            prop: "distributionMode",
            solt: true,
           // viewVisdiplay: false,
            formsolt: true

        },
        {

            label: "配送地址",
            prop: "address",
            hide: true,
            solt: true,
            //formsolt: true
        },
        {
            label: "供货商",
            prop: "supplierName",
            hide: true,
            solt: true,
            //formsolt: true
        },
        {
            label: "供货单状态",
            prop: "status",
            type: "input",
            solt: true,
            formsolt: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "发布时间",
            prop: "createTime",
            type: "datetime",
            sortable: true,
            width:"200",
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "备注",
            prop: "remarks",
            type: "textarea",
            hide: true,
            span: 24,
            max: 255
        },
        {
            label: "商品清单",
            prop: "goodsList",
            span: 24,
            hide: true,
            solt: true,
            formsolt: true
        },
        // {
        //     label: "创建人",
        //     prop: "createBy",
        //     type: "input",
        //     addVisdiplay: false,
        //     editVisdiplay: false
        // },
        // {
        //     label: "状态",
        //     prop: "status",
        //     type: "radio",
        //     addVisdiplay: false,
        //     editVisdiplay: false,
        //     dicData: DIC.STATE
        // },
        // {
        //     label: "更新时间",
        //     prop: "updateTime",
        //     type: "datetime",
        //     format: "yyyy-MM-dd HH:mm:ss",
        //     hide: true,
        //     addVisdiplay: false,
        //     editVisdiplay: false
        // },
        // {
        //     label: "更新人",
        //     prop: "updateBy",
        //     type: "input",
        //     hide: true,
        //     addVisdiplay: false,
        //     editVisdiplay: false
        // },
        // {
        //     label: "是否删除",
        //     prop: "deleteFlag",
        //     type: "radio",
        //     hide: true,
        //     addVisdiplay: false,
        //     editVisdiplay: false,
        //     dicData: DIC.DELETE_FLAG
        // },



        {
            prop: "selectShop",
            span: 24,
            hide: true,
            solt: true,
            formsolt: true
        },
        {

            prop: "re",
            type: "button",
            hide: true,
            span: 5,
            max: 10,
            formsolt: true
        }
        ,
        {

            prop: "confirmDelivery",
            type: "button",
            hide: true,
            span: 5,
            max: 10,
            formsolt: true
        }
    ]
};